<template>
  <div
    class="flex-auto flex flex-wrap items-end xs-justify-center col-12"
  >
    <div class="flex items-center">
      <div class="h5n flex flex-column">
        <div class="flex xs-col-12 xs-justify-center">
          {{ session.type }}
        </div>
        <div
          v-if="session.startDate !== session.endDate"
          class="block h6n flex flex-wrap"
        >
          <div class="flex xs-col-12 xs-justify-center mr1 xs-mr0">
            <span class="mr1">
              <i class="icon icon-date-check-icon mr1"></i>{{ session.startDate }}
            </span>
            <span>
              <i class="icon icon-clock mr1"></i>{{ session.startTime }}
            </span>
          </div>
          <div class="flex xs-col-12 xs-justify-center mr1 xs-mr0">-</div>
          <div class="flex xs-col-12 xs-justify-center mr1 xs-mr0">
            <span class="mr1">
              <i class="icon icon-date-check-icon mr1"></i>{{ session.endDate }}
            </span>
            <span>
              <i class="icon icon-clock mr1"></i>{{ session.endTime }}</span>
          </div>
        </div>
        <div v-else class="h6n flex flex-wrap xs-col-12">
          <div class="flex">
            <span class="mr1">
              <i class="icon icon-date-check-icon mr1"></i>{{ session.startDate }}
            </span>
            <span>
              <i class="icon icon-clock mr1"></i>{{ session.startTime }}
            </span>
          </div>
          <div class="flex">-</div>
          <div class="flex">
            <span>{{ session.endTime }}</span>
          </div>
        </div>
        <div class="h6n flex flex-wrap xs-col-12" v-if="session.horse">
          <span class="mr1">
            Cheval: {{ session.horse.wtitle }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="
        flex
        flex-grow
        full-height
        justify-end
        xs-justify-center
        xs-col-12
      "
    >
      <div
        v-if="!['single-session'].includes(session.billet_type)"
        tabindex="0"
        role="button"
        class="
          lg-py1
          pointer
          px1
          white
          black-btn
          flex
          items-center
        "
        :class="session.isCancelable ? '' : ' disabled'"
        style="max-width: 155px"
        @click="cancel(participant, contract, session)"
      >
        <div class="mx3 md-xs-my0 center">
          <div class="col-12 col-12">
            <span class="md-xs-h7n h6n semi-bold col-12 caps-text col-12">{{ session.isCancelable ? 'Annuler': "Délai d'annulation dépassé" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { inject } from 'vue';

export default {
  props: ['participant', 'contract', 'session'],
  setup () {
    const cancel = inject('cancel');

    return { cancel };
  }
};
</script>
